var rotation = window.innerWidth < 500 ? 45 : 0
var ticksLimit = window.innerWidth < 500 ? 8 : 10
export const chartDefaults = {
    lineChart: {
        maintainAspectRatio: false,
        elements: {
            line: {
                fill: false,
                borderWidth: 2
            },
            point: {
                radius: 4,
            },
        },
        layout: {
            padding: {
                top: 16,
                right: 16,
                bottom: 16,
                left: 16
            }
        },
        legend: { display: false },
        tooltips: {
            enabled: true,
            borderColor: '#000',
            borderWidth: 0.5,
            titleFontColor: '#000',
            bodyFontColor: '#000',
            backgroundColor: '#fff',
            callbacks: {
                label: function (tooltipItems, data) {
                    return data.datasets[tooltipItems.datasetIndex].label + ' : ' + tooltipItems.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                }
            }
        },
        scales: {
            xAxes: [{
                display: true,
                gridLines: {
                    drawOnChartArea: false,
                    drawTicks: false
                },

                ticks: {
                    padding: 10,
                    reverse: true,
                    maxTicksLimit: ticksLimit,
                    autoSkip: true,
                    maxRotation: 45,
                    minRotation: 45
                }
            }],
            yAxes: [{
                display: true,
                gridLines: {
                    drawTicks: false,
                    drawBorder: false,
                    zeroLineColor: '#e5e5e5'
                },
                ticks: {
                    padding: 10,
                    beginAtZero: true,
                    maxTicksLimit: 5,
                    maxRotation: rotation,
                    minRotation: rotation,
                    callback: function (value) {
                        if (parseInt(value) >= 1000) {
                            return '' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                        } else {
                            return '' + value;
                        }
                    }
                }
            }]
        }
    },
    barHorizontal: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                right: 15,
                left: 10,
                top: 16,
                bottom: 16,
            }
        },
        tooltips: {
            enabled: true,
            borderColor: '#000',
            borderWidth: 0.5,
            titleFontColor: '#000',
            bodyFontColor: '#000',
            backgroundColor: '#fff'
        },
        legend: {
            display: false,
        },
        scales: {
            xAxes: [{
                gridLines: {
                    display: true,
                    drawTicks: false,
                    tickMarkLength: 5,
                    drawBorder: false
                },
                ticks: {
                    padding: 5,
                    beginAtZero: true,
                    fontSize: 11,
                }
            }],
            yAxes: [{
                barPercentage: 0.75,
                gridLines: {
                    display: true,
                    drawTicks: true,
                    drawOnChartArea: false
                },
                ticks: {
                    beginAtZero: true,
                    fontSize: 12,
                    lineHeight: 2,
                    padding: 10,
                    reverse: true,
                    maxTicksLimit: 20,
                    autoSkip: true,
                }
            }],
        }
    },
    lineChartVacunas: {
        maintainAspectRatio: false,
        elements: {
            line: {
                fill: false,
                borderWidth: 2,
                position: "right"
            },
            point: {
                radius: 4,
            },
        },
        layout: {
            padding: {
                top: 16,
                right: 16,
                bottom: 16
            }
        },
        legend: {
            display: false,
        },
        tooltips: {
            enabled: true,
            borderColor: '#000',
            borderWidth: 0.5,
            titleFontColor: '#000',
            bodyFontColor: '#000',
            backgroundColor: '#fff',
            callbacks: {
                label: function (tooltipItems, data) {
                    return data.datasets[tooltipItems.datasetIndex].label + ' : ' + tooltipItems.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                }
            }
        },
        scales: {
            xAxes: [{
                display: true,
                gridLines: {
                    drawOnChartArea: false,
                    drawTicks: false
                },

                ticks: {
                    padding: 10,
                    reverse: false,
                    maxTicksLimit: ticksLimit,
                    autoSkip: true,
                    maxRotation: 45,
                    minRotation: 45
                }
            }],
            yAxes: [{
                display: true,
                gridLines: {
                    drawTicks: false,
                    drawBorder: false,
                    zeroLineColor: '#e5e5e5'
                },
                ticks: {
                    lineHeight: 3,
                    padding: 10,
                    beginAtZero: true,
                    maxTicksLimit: 5,
                    maxRotation: rotation,
                    minRotation: rotation,
                    callback: function (value) {
                        if (parseInt(value) >= 1000) {
                            return '' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                        } else {
                            return '' + value;
                        }
                    }
                }
            }]
        }
    }
}